import { useScrolled } from "@/hooks/useReveal";
import { useActiveSection } from "@/hooks/useActiveSection";
import { kontakt } from "@/mocks/lokacija";
import SectionLink from "@/components/base/SectionLink";

const sekcije = ["ponudba", "galerija", "kontakt"];

const postavke = [
  { hash: "ponudba", label: "Ponudba", icon: "ri-restaurant-2-line" },
  { hash: "galerija", label: "Galerija", icon: "ri-image-line" },
  { hash: "kontakt", label: "Kontakt", icon: "ri-map-pin-line" },
];

/**
 * Bottom quick navigation shown only on phones and small tablets.
 */
export default function MobileActionBar() {
  const aktivna = useActiveSection(sekcije);
  const vidna = useScrolled(420);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 border-t border-background-300/80 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md transition-transform duration-500 ease-smooth lg:hidden ${
        vidna ? "translate-y-0" : "pointer-events-none translate-y-full"
      }`}
      aria-hidden={!vidna}
    >
      <nav className="grid grid-cols-4" aria-label="Hitra navigacija">
        {postavke.map((postavka) => {
          const jeAktivna = aktivna === postavka.hash;

          return (
            <SectionLink
              key={postavka.hash}
              hash={postavka.hash}
              ariaCurrent={jeAktivna ? "true" : undefined}
              className={`relative flex cursor-pointer flex-col items-center justify-center gap-1 py-2.5 transition-colors duration-300 ${
                jeAktivna ? "text-secondary-600" : "text-foreground-600"
              }`}
            >
              <span
                className={`absolute inset-x-4 top-0 h-px transition-colors duration-300 ${
                  jeAktivna ? "bg-secondary-500" : "bg-transparent"
                }`}
              />
              <i className={`${postavka.icon} text-[18px]`} />
              <span className="font-label text-[9px] font-semibold uppercase tracking-[0.12em]">
                {postavka.label}
              </span>
            </SectionLink>
          );
        })}

        <a
          href={kontakt.navigacija}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer flex-col items-center justify-center gap-1 rounded-none bg-accent-500 py-2.5 text-primary-950 transition-colors duration-300 hover:bg-accent-600"
        >
          <i className="ri-route-line text-[18px]" />
          <span className="font-label text-[9px] font-semibold uppercase tracking-[0.12em]">
            Pot do nas
          </span>
        </a>
      </nav>
    </div>
  );
}